import { writable } from 'svelte/store';

// Route history
export const history = writable(['/']);

export interface ParaUser {
	id: string;
	walletAddress: string;
	email: string;
	member: boolean;
}

export const user = writable<ParaUser | undefined>();

export interface ParaSession {
	logout: () => Promise<void>;
	init: () => Promise<void>;
}
